import React from "react";
import { t } from "i18next";

export function NotifFilterTabButtons({ tab, setTab }) {
    return (
        <div className="flex gap-2 md:gap-2 overflow-x-auto overflow-y-hidden scrollbar_hide py-1 -mx-1 min-w-0">
            <button
                type="button"
                className={`min-w-[120px] h-10 px-4 py-0 text-sm font-medium rounded-lg whitespace-nowrap flex-shrink-0 transition-colors ${
                    tab === "agroland"
                        ? "bg-[#147F26] text-white"
                        : "bg-gray-100 text-[#222] hover:bg-gray-200"
                }`}
                onClick={() => setTab("agroland")}
            >
                {t('appTitle')}
            </button>
            <button
                type="button"
                className={`min-w-[120px] h-10 px-4 py-0 text-sm font-medium rounded-lg whitespace-nowrap flex-shrink-0 transition-colors ${
                    tab === "promotions"
                        ? "bg-[#147F26] text-white"
                        : "bg-gray-100 text-[#222] hover:bg-gray-200"
                }`}
                onClick={() => setTab("promotions")}
            >
                {t('promotions')}
            </button>
        </div>
    );
}
